import { UuiFlexlayout, UuiLogo } from "@aonunited/react";
import React, { useEffect, useState } from "react";
import "./bottomBar.scss";
import { isInternaluser } from "../../api/auth/okta";
import { getApplicationConfig } from "../../constants/utilities";
var BottomBar = function (_a) {
    var _b = useState(false), trustCookie = _b[0], showTrustCookie = _b[1];
    var _showOneTrustMessge = function () {
        var _a;
        var internalUser = isInternaluser();
        var applicationConfig = getApplicationConfig();
        var oneTrustDiv = document.getElementById('oneTrustFooter');
        //Only show the OneTrust cookie banner for External users of MarketReView and MarketPreView
        if (!internalUser && applicationConfig.applicationId !== 3) {
            var oneTrustScript = document.createElement('script');
            oneTrustScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
            oneTrustScript.type = 'text/javascript';
            oneTrustScript.charset = 'UTF-8';
            if (applicationConfig.applicationId === 2) {
                if (window.location.host.includes("qamarketreview.abconnect.com") || window.location.host.includes("devmarketreview.abconnect.com")) {
                    oneTrustScript.setAttribute("data-domain-script", '8f38354a-4c43-49f1-8c63-b97d366e9979-test');
                }
                else {
                    oneTrustScript.setAttribute("data-domain-script", '8f38354a-4c43-49f1-8c63-b97d366e9979');
                }
            }
            else if (applicationConfig.applicationId === 1) {
                if (window.location.host.includes("qamarketpreview.abconnect.com") || window.location.host.includes("devmarketpreview.abconnect.com")) {
                    oneTrustScript.setAttribute("data-domain-script", 'a9e832f2-7074-465b-b793-1b91734bc5a6-test');
                }
                else {
                    oneTrustScript.setAttribute("data-domain-script", 'a9e832f2-7074-465b-b793-1b91734bc5a6');
                }
            }
            var doc = document.getElementsByTagName('head');
            if (doc) {
                (_a = doc === null || doc === void 0 ? void 0 : doc.item(0)) === null || _a === void 0 ? void 0 : _a.appendChild(oneTrustScript);
                showTrustCookie(true);
            }
        }
    };
    useEffect(function () {
        _showOneTrustMessge();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "oneTrustFooter", style: { bottom: "90px", zIndex: "9", boxSizing: "border-box", right: "0", display: trustCookie ? "block" : "none" } },
            React.createElement("div", { style: { float: "right" } },
                React.createElement("a", { className: "optanon-toggle-display USFooterLink " }, "Do Not Sell My Data"),
                React.createElement("a", { className: "optanon-toggle-display EUFooterLink" }, "Cookie Preferences"))),
        React.createElement(UuiFlexlayout, { justify: "space-between", alignItems: "center", className: "bottombar" },
            React.createElement(UuiFlexlayout, { alignItems: "flex-end", gap: "xs" },
                React.createElement(UuiLogo, { style: { UuiLogoWidth: "6" }, className: 'logo-design-bottom' })),
            React.createElement("div", { className: "copycontainer" },
                React.createElement("p", { className: "copyrighticon" }, "\u00A9"),
                React.createElement("p", { className: "copyrighttext" }, "Copyright 2025 Aon PLC")))));
};
export default BottomBar;
